import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, CircularProgress, SxProps, Theme, Typography } from '@mui/material';

import { stylesLoading, stylesLoadingContent, stylesLoadingTitle } from './Loading.styles';

type LoadingProps = {
  message?: string;
  sx?: SxProps<Theme>;
};

export function Loading(props: LoadingProps) {
  const { message, sx } = props;
  const { t } = useTranslation('components');

  return (
    <Box sx={{ ...stylesLoading, ...sx } as SxProps<Theme>}>
      <CircularProgress size={55} />
      <Typography variant='h2' sx={stylesLoadingTitle}>
        {t('loading.loadingTitle')}
      </Typography>
      <Typography variant='bodySM' sx={stylesLoadingContent}>
        {message}
      </Typography>
    </Box>
  );
}
